export default [
    {
        label: '首页',
        icon: 'iconshouyeweixuan',
        iconActive: 'iconshouyeweixuan',
        path: '/home',
        selected: true
    },
    {
        label: '资讯中心',
        icon: 'iconredianzhongxinweixuan1',
        iconActive: 'iconredianzhongxinweixuan1',
        path: '/hot'
    },
    {
        label: '我的订阅',
        icon: 'icondingyuezhongxinweixuan',
        iconActive: 'icondingyuezhongxinweixuan',
        path: '/rss'
    },
    {
        label: '微信平台'
    },
    {
        label: '地产排行',
        icon: 'iconbaiqiangbangweixuan',
        iconActive: 'iconbaiqiangbangweixuan',
        path: '/landTop'
    },
    {
        label: '品牌百强',
        icon: 'iconzhuantiweixuan',
        iconActive: 'iconzhuantiweixuan',
        path: '/top'
    },
    // {
    //     label: '事件中心',
    //     icon: 'iconshijiankuweixuan',
    //     iconActive: 'iconshijiankuxuanzhong',
    //     path: '/event'
    // },
    {
        label: '阅读数监控',
        path: '/audit',
        icon: 'iconyuedushujiankong',
        iconActive: 'iconyuedushujiankong',
        hot: true
    },
    {
        label: '公众号对比',
        path: '/contrast',
        icon: 'iconduibi',
        iconActive: 'iconduibi',
        blank: true
    },
    {
        label: '发现好媒体',
        path: '/discover',
        icon: 'iconsucaizhongxinweixuan',
        iconActive: 'iconsucaizhongxinweixuan'
    },
    // {
    //     label: '素材中心',
    //     icon: 'iconsucaizhongxinweixuan',
    //     iconActive: 'iconsucaizhongxinxuanzhong',
    //     path: '/material',
    //     blank: true
    // },
    // {
    //     label: '行业专题',
    //     icon: 'iconzhuantiweixuan',
    //     iconActive: 'iconzhuantixuanzhong',
    //     path: '/subject'
    // },
    {
        label: '房企动态'
    },
    // {
    //     label: '应用中心',
    //     icon: 'iconyingyongzhongxinweixuan',
    //     iconActive: 'iconyingyongzhongxinxuanzhong',
    //     path: '/resources'
    // },
    // {
    //     label: '公众号对比',
    //     path: '/contrast',
    //     blank: true
    // },
    // {
    //     label: '企业品牌馆',
    //     path: '/brand'
    // },
    // {
    //     label: '发现好媒体',
    //     path: '/discover'
    // },
    // {
    //     label: '图文工具',
    //     path: '/generator'
    // },
    // {
    //     label: '阅读数监控',
    //     path: '/audit',
    //     hot: true
    // },
    // {
    //     label: '运营日历',
    //     path: '/calendar',
    //     new: true
    // },
    {
        label: '舆情监测',
        path: '/opinion',
        icon: 'iconyuqingjiance',
        iconActive: 'iconyuqingjiance'
    },
    {
        label: '舆情统计',
        path: '/yqStatistics',
        icon: 'iconyuqingjiance1',
        iconActive: 'iconyuqingjiance1'
    }
    // {
    //     label: 'demo',
    //     path: '/demo'
    // }
]
